import { FilterMultiSelect, SearchField } from '@/modules/common';
import {
  type EventFiltersType,
  type FiltersChangeType,
} from '@/modules/events/hooks';
import { EventOrderStatus } from '@/modules/events/types';

const statusOptions = [
  { value: 'New', id: EventOrderStatus.New },
  { value: 'Pending', id: EventOrderStatus.Pending },
  { value: 'Printing', id: EventOrderStatus.Printing },
  { value: 'Completed', id: EventOrderStatus.Completed },
  { value: 'Canceled', id: EventOrderStatus.Canceled },
  { value: 'Failed', id: EventOrderStatus.Failed },
];

export const OrdersFilters = ({
  filters,
  onFilters,
}: {
  filters: EventFiltersType;
  onFilters: FiltersChangeType;
}) => {
  return (
    <div className="flex gap-4 w-full">
      <FilterMultiSelect
        options={statusOptions}
        label="Status"
        values={filters.statuses || []}
        onChange={(value: EventOrderStatus[]) => onFilters({ statuses: value })}
      />
    </div>
  );
};
